import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Base } from './base';
import { bisect, isValid } from '../utils';
/**
 * 将连续的定义域分段，每一段所有的值对应离散的值域中一个值
 */
export var Threshold = /*#__PURE__*/function (_Base) {
  _inherits(Threshold, _Base);
  _createClass(Threshold, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0.5],
        range: [0, 1]
      };
    }
  }]);
  function Threshold(options) {
    _classCallCheck(this, Threshold);
    return _possibleConstructorReturn(this, _getPrototypeOf(Threshold).call(this, options));
  }
  /**
   * 二分查找到输入值在哪一段，返回对应的值域中的值
   */
  _createClass(Threshold, [{
    key: "map",
    value: function map(x) {
      if (!isValid(x)) return this.options.unknown;
      var index = bisect(this.thresholds, x, 0, this.n);
      return this.options.range[index];
    }
    /**
     * 在值域中找到对应的值，并返回在定义域中属于哪一段
     */
  }, {
    key: "invert",
    value: function invert(y) {
      var range = this.options.range;
      var index = range.indexOf(y);
      var domain = this.thresholds;
      return [domain[index - 1], domain[index]];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Threshold(this.options);
    }
  }, {
    key: "rescale",
    value: function rescale() {
      var _this$options = this.options,
        domain = _this$options.domain,
        range = _this$options.range;
      this.n = Math.min(domain.length, range.length - 1);
      this.thresholds = domain;
    }
  }]);
  return Threshold;
}(Base);